import * as NS from '../namespace'

export const SAMPLE_REVIEW_POINTS: NS.IReview['score_point'] = {
    reliable_point: 0,
    economic_point: 0,
    safety_point: 0,
    total: 0,
    comfort_point: 0,
    contrallabilty_point: 0,
    cross_country_point: 0
}

